const farm = {
    ru: {
        farm: {
            tooltip: {
                users: "Gestion utilisateurs",
                export: "Exporter données ferme",
                upload: "Envoyer données ferme",
                updateInspections: "Recalculer moyenne contrôle",
                reset: "Remettre ferme à zéro",
                delete: "Supprimer ferme",
                access: "Accéder à la ferme"
            },
            form: {
                newFarm: "Nouvelle ferme",
                editFarm: "Modifier information ferme",
                userFarm: "Gestion des utilisateurs",
                uploadData: "Envoyer données de base",
                name: "Nom de l'exploitation",
                manager: "Nom du manager",
                address: "Adresse de l'exploitation"
            },
            dialog: {
                message: "Supprimer la ferme {farm} ?",
                reset: "Remettre la ferme {farm} à zéro ?"
            },
            users: {
                others: "Autres inscrits",
                linked: "Utilisateur(s) de la ferme",
                table: {
                    user: "Utilisateur",
                    role: "Role"
                }
            },
            roles: {
                manager: "менеджер",
                collaborator: "Collaborateur",
                visitor: "Visiteur"
            },
            dashboard: {
                address: "адрес",
                cattle: "стадо",
            }
        },
        building: {
            title: {
                editBuilding: "Modifier information bâtiment",
                newBuilding: "Nouveau bâtiment"
            },
            form: {
                name: "Nom du bâtiment",
                type: "Type de bâtiment",
                maximumCapacity: "Capacité maximum"
            },
            type: {
                stabling: "Stabulation",
                stall: "Logette"
            }
        }
    },
    fr: {
        farm: {
            tooltip: {
                users: "Gestion utilisateurs",
                export: "Exporter données ferme",
                upload: "Envoyer données ferme",
                updateInspections: "Recalculer moyenne contrôle",
                reset: "Remettre ferme à zéro",
                delete: "Supprimer ferme",
                access: "Accéder à la ferme"
            },
            form: {
                newFarm: "Nouvelle ferme",
                editFarm: "Modifier information ferme",
                userFarm: "Gestion des utilisateurs",
                uploadData: "Envoyer données de base",
                name: "Nom de l'exploitation",
                manager: "Nom du manager",
                address: "Adresse de l'exploitation"
            },
            dialog: {
                message: "Supprimer la ferme {farm} ?",
                reset: "Remettre la ferme {farm} à zéro ?"
            },
            users: {
                others: "Autres inscrits",
                linked: "Utilisateur(s) de la ferme",
                table: {
                    user: "Utilisateur",
                    role: "Role"
                }
            },
            roles: {
                manager: "Manager",
                collaborator: "Collaborateur",
                visitor: "Visiteur"
            },
            dashboard: {
                address: "Adresse",
                cattle: "Troupeau",
            }
        },
        building: {
            title: {
                editBuilding: "Modifier information bâtiment",
                newBuilding: "Nouveau bâtiment"
            },
            form: {
                name: "Nom du bâtiment",
                type: "Type de bâtiment",
                maximumCapacity: "Capacité maximum"
            },
            type: {
                stabling: "Stabulation",
                stall: "Logette"
            }
        }
    }
}

export default farm